import { Drawer } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useCurrencyContext } from "../providers/currency.provider";
import { IExpense2 } from "../types/types";
import { toFixedDisplay } from "../utils/number.utils";

export default function ExpensesDrawerList({
  open,
  onClose,
  expenses,
  title,
}: {
  open: boolean;
  onClose: () => void;
  title?: string;
  expenses?: IExpense2[];
}) {
  const navigate = useNavigate();
  const { currency } = useCurrencyContext();
  return (
    <Drawer
      title={title ?? ""}
      placement={"right"}
      onClose={onClose}
      open={open}
      key={"right"}
      size={512}
      resizable={true}
    >
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200">
              <th className="text-left py-3 px-4 font-semibold text-foreground">
                Date
              </th>
              <th className="text-left py-3 px-4 font-semibold text-foreground">
                Description
              </th>
              <th className="text-left py-3 px-4 font-semibold text-foreground">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {expenses?.map((expense) => (
              <tr
                key={expense.id}
                onClick={() =>
                  navigate(`groups/${expense.groupId}/expense/${expense.id}`)
                }
                className="border-b border-slate-100 hover:bg-slate-50 transition cursor-pointer"
              >
                <td className="py-3 px-4 text-muted-foreground">
                  {dayjs(expense.expenseDate).format("DD MMM YYYY")}
                </td>
                <td className="py-3 px-4 text-foreground font-medium">
                  {expense.comments}
                </td>
                <td className="py-3 px-4 text-foreground font-semibold text-primary">
                  {currency}
                  {toFixedDisplay(expense.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Drawer>
  );
}
